import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconBearingBPFO = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.black }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_4078_37360)'>
            <path d='M9 3.77734L7 3.77734L7 -0.444336L9 -0.444336L9 3.77734ZM9 10.1113L7 10.1113L7 5.88867L9 5.88867L9 10.1113ZM9 16.4443L7 16.4443L7 12.2227L9 12.2227L9 16.4443Z' fill={color} />
        </g>
    </svg>;
};

IconBearingBPFO.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconBearingBPFO;
